<template>
  <v-container class="pa-0 ma-0" fluid>
    <v-card elevation="0" min-width="100%">
      <common-data-table
        :headers="headers"
        collectionName="locations"
        ref="editTable"
        @click:row="rowClicked"
      >
        <template v-slot:newItemPopup="{ close, item, formKey }">
          <common-editing-popup
            ref="editPopup"
            title="Add a new location"
            saveBtnTitle="Add location"
            :originalItem="item"
            :canSubmit="formValid"
            @close="editingFinished($event, close)"
            :key="'location-edit-' + (item ? item.id : formKey)"
            collectionName="locations"
            :defaultItem="{
              country: {
                code: 'GB',
                name: 'United Kingdom of Great Britain and Northern Ireland',
              },
            }"
            :successMessage="'Location <b>{{name}}</b> was added successfully'"
          >
            <template v-slot:default="{ editedItem }">
              <add-location
                :formValid.sync="formValid"
                :editedItem="editedItem"
              ></add-location>
            </template>
          </common-editing-popup>
        </template>
      </common-data-table>
    </v-card>
  </v-container>
</template>

<script>
import AddLocation from './components/AddLocation.vue'
import CommonDataTable from '../../components/CommonDataTable.vue'
import CommonEditingPopup from '../../components/CommonEditingPopup.vue'

export default {
  name: 'LocationSettings',
  components: {
    AddLocation,
    CommonDataTable,
    CommonEditingPopup,
  },
  data() {
    return {
      formValid: false,
      headers: [
        {
          text: 'Name',
          value: 'name',
        },
        {
          text: 'Town / City',
          value: 'city',
        },
        {
          text: 'Postcode',
          value: 'postcode',
        },
      ],
    }
  },
  computed: {
    formKey() {
      return new Date().toString()
    },
  },
  methods: {
    editingFinished(cancelled, close) {
      if (!cancelled) {
        this.$store.dispatch('getLocations', true)
      }
      close()
    },
    rowClicked(data) {
      this.$router.push({
        name: 'location-details',
        params: { id: data.id },
      })
    },
  },
}
</script>
